// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GWfmb","list":"styles_list__+lKQf","pagination":"styles_pagination__GoiGS","btn":"styles_btn__8w1LG"};